import katex from "katex";
import {unescapes} from "@/lib/Markdown/helper";

const regex = /(\${1,2})((?:\\.|[\s\S])*?)\1/g;

const latex = (text: string): string => {
  let block;
  while ((block = regex.exec(text)) !== null) {
    text = latexItem(text, block);
  }
  return `<p>${text}</p>`;
};

const latexItem = (text: string, block: RegExpExecArray): string => {
  if (block) {
    if (block[0] === "$$") {
      return text;
    }

    const unescaped = unescapes(block[2]);
    let math = katex.renderToString(unescaped);
    math = math.replace(/\n/g, "");

    if (block[1] === "$" || block[0] === block.input) {
      return `<p class="latex-math">${text.replace(block[0], math)}</p>`;
    }

    return text.replace(
      block[0],
      `</p><div class="latex-math" style="text-align:center">${math}</div><p>`
    );
  }
  return text;
};

export default latex;
